export default __webpack_public_path__ + "static/media/contact_us_demo.01be46eb.svg";